import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = {
  key: 0,
  class: "l-modal__bg"
}
const _hoisted_2 = { class: "signup" }
const _hoisted_3 = { class: "loading" }
const _hoisted_4 = { style: {"padding-bottom":"300px"} }
const _hoisted_5 = { class: "pt-15" }
const _hoisted_6 = { class: "text-area" }
const _hoisted_7 = { class: "error" }
const _hoisted_8 = { style: {"padding-top":"16px"} }
const _hoisted_9 = { class: "name-area" }
const _hoisted_10 = { class: "error" }
const _hoisted_11 = { class: "error" }
const _hoisted_12 = { class: "birth-area" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_20 = { class: "text-area" }
const _hoisted_21 = { class: "error" }
const _hoisted_22 = { class: "button-area" }

import { onMounted, ref } from "vue";
import router from "../router";

import { Field, Form, ErrorMessage } from "vee-validate";
import CommonButton from "./CommonButton.vue";
import { UserInfoStore } from "../store/UserInfoStore";


import * as yup from "yup";
import liff from "@line/liff";
import { USER } from "../consts/common";

const yearNum: number = 100;

export default /*@__PURE__*/_defineComponent({
  __name: 'SignUp',
  setup(__props) {

const yearList: number[] = [];
const monthList = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
let dateList: number[] = [];
const error = ref("");
const isUser = ref(false);
const updated = ref(false)

const userInfoStore = UserInfoStore();
const nickname = ref("");
const lastName = ref("");
const firstName = ref("");
const birthYear = ref(2000);
const birthMonth = ref(1);
const birthDate = ref(1);
const mailAddress = ref("");
const loading = ref(false);
const validationSchema = ref(
  yup.object().shape({
    nickname: yup
      .string()
      .trim()
      .required("ニックネームは必須です")
      .min(1)
      .label("ニックネーム"),
    lastName: yup.string().trim().required("姓は必須です").min(1).label("姓"),
    firstName: yup.string().trim().required("名は必須です").min(1).label("名"),
    mailAddress: yup
      .string()
      .required("メールアドレスは必須です")
      .email()
      .label("メールアドレス"),
  })
);
onMounted(() => {
  if (userInfoStore.userDetail.user_state == USER) {
    isUser.value = true;
    document.title = "プロフィール更新"
    // 登録済の情報を初期値で入れる
    setInitialData();
  } else {
    isUser.value = false;
    document.title = "プロフィール登録"
  }
  const year = new Date().getFullYear();
  for (let i: number = 0; i < yearNum; i++) {
    yearList.unshift(year - i);
  }
});

const changeDateList = () => {
  if (!birthYear.value || !birthMonth.value) {
    dateList.splice(0);
    return (dateList = [...Array(31)].map((_, i) => i + 1));
  } else {
    dateList.splice(0);
    dateList = [
      ...Array(new Date(birthYear.value, birthMonth.value, 0).getDate()),
    ].map((_, i) => i + 1);
    if (
      dateList[dateList.length - 1] < birthDate.value
    ) {
      birthDate.value = 1;
    }
    return dateList;
  }
};

function setInitialData() {
  // ユーザー情報未登録の場合は
  if (!userInfoStore.userDetail.name) return
  nickname.value = userInfoStore.userDetail.name;
  firstName.value = userInfoStore.userDetail.first_name;
  lastName.value = userInfoStore.userDetail.last_name;
  birthYear.value = userInfoStore.userDetail.birthday ? +userInfoStore.userDetail.birthday.substring(0, 4) : 2000;
  birthMonth.value = userInfoStore.userDetail.birthday ? +userInfoStore.userDetail.birthday.substring(5, 7) : 1;
  birthDate.value = userInfoStore.userDetail.birthday ? +userInfoStore.userDetail.birthday.substring(8, 10) : 1;
  mailAddress.value = userInfoStore.userDetail.email;
}


// 登録処理
const onSubmit = async () => {
  // 複数回リクエストが飛ばないようにする
  if (loading.value) return;
  loading.value = true;
  const birthDay =
    birthYear.value +
    "-" +
    String(birthMonth.value).padStart(2, "0") +
    "-" +
    String(birthDate.value).padStart(2, "0");
  const params = {
    name: nickname.value,
    first_name: firstName.value,
    last_name: lastName.value,
    birthday: birthDay,
    email: mailAddress.value,
    line_access_token: liff.getAccessToken(),
  };
  await userInfoStore
    .updateUserInfo(params)
    .then(async (v) => {
      loading.value = false;
      updated.value = true
      // state.value = 0
      if (v) {
        setTimeout(() => {
        if (userInfoStore.isRegistFromProjectDetail.show && !userInfoStore.bankInfo.id) {
        router.replace("/bank")
        } else if (userInfoStore.isRegistFromProjectDetail.show && (!userInfoStore.userSnsInfo.length || !userInfoStore.userSnsInfo.find((v) => v.media_type == userInfoStore.isRegistFromProjectDetail.mediaType))) {
          router.replace("/sns-accounts")
        }  else if (userInfoStore.isRegistFromProjectDetail.show && userInfoStore.addressInfo.id < 0) {
          router.replace("/address")
        } else {
        router.back()
        }
      },1000)
      }
    })
};
function focus() {
  const signup = document.getElementsByClassName(
    "signup"
  )[0] as HTMLElement;
  signup.style.overflowY = "visible"
}
function blur() {
  const signup = document.getElementsByClassName(
    "signup"
  )[0] as HTMLElement;
  signup.style.overflow= "hidden"
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, _cache[7] || (_cache[7] = [
        _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
      ]), 512 /* NEED_PATCH */), [
        [_vShow, loading.value]
      ]),
      (!updated.value)
        ? (_openBlock(), _createBlock(_unref(Form), {
            key: 0,
            class: "form",
            validationSchema: validationSchema.value
          }, {
            default: _withCtx(({ meta: { valid } }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", null, "ニックネーム", -1 /* HOISTED */)),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(Field), {
                      type: "text",
                      modelValue: nickname.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nickname).value = $event)),
                      name: "nickname",
                      placeholder: "ニックネーム",
                      class: "text-field",
                      onFocus: focus,
                      onBlur: blur,
                      disabled: loading.value,
                      tabindex: "1"
                    }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                    _createElementVNode("div", null, [
                      _createVNode(_unref(ErrorMessage), { name: "nickname" }, {
                        default: _withCtx(({ message }) => [
                          _createElementVNode("p", _hoisted_7, _toDisplayString(message), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", null, "名前", -1 /* HOISTED */)),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_unref(Field), {
                      type: "text",
                      modelValue: lastName.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lastName).value = $event)),
                      name: "lastName",
                      placeholder: "山田",
                      class: "name-text-field",
                      disabled: loading.value,
                      onFocus: focus,
                      onBlur: blur,
                      tabindex: "2"
                    }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                    _createVNode(_unref(Field), {
                      type: "text",
                      modelValue: firstName.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((firstName).value = $event)),
                      name: "firstName",
                      placeholder: "太郎",
                      class: "name-text-field",
                      disabled: loading.value,
                      onFocus: focus,
                      onBlur: blur,
                      tabindex: "3"
                    }, null, 8 /* PROPS */, ["modelValue", "disabled"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_unref(ErrorMessage), { name: "lastName" }, {
                      default: _withCtx(({ message }) => [
                        _createElementVNode("p", _hoisted_10, _toDisplayString(message), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_unref(ErrorMessage), { name: "firstName" }, {
                      default: _withCtx(({ message }) => [
                        _createElementVNode("p", _hoisted_11, _toDisplayString(message), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("label", null, "生年月日", -1 /* HOISTED */)),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((birthYear).value = $event)),
                      name: "birthYear",
                      class: "number-field",
                      disabled: loading.value,
                      placeholder: "年",
                      tabindex: "4"
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(yearList, (year) => {
                        return _createElementVNode("option", {
                          key: year,
                          value: year
                        }, _toDisplayString(year), 9 /* TEXT, PROPS */, _hoisted_14)
                      }), 64 /* STABLE_FRAGMENT */))
                    ], 8 /* PROPS */, _hoisted_13), [
                      [_vModelSelect, birthYear.value]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((birthMonth).value = $event)),
                      name: "birthMonth",
                      class: "number-field",
                      disabled: loading.value,
                      tabindex: "5"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthList.value, (month) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: month,
                          value: month
                        }, _toDisplayString(month), 9 /* TEXT, PROPS */, _hoisted_16))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 8 /* PROPS */, _hoisted_15), [
                      [_vModelSelect, birthMonth.value]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((birthDate).value = $event)),
                      class: "number-field",
                      name: "birthDate",
                      disabled: loading.value,
                      tabindex: "6"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changeDateList(), (date) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: date,
                          value: date
                        }, _toDisplayString(date), 9 /* TEXT, PROPS */, _hoisted_18))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 8 /* PROPS */, _hoisted_17), [
                      [_vModelSelect, birthDate.value]
                    ])
                  ]),
                  (error.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("p", null, _toDisplayString(error.value), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", null, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", null, "メールアドレス", -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_unref(Field), {
                        type: "text",
                        modelValue: mailAddress.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((mailAddress).value = $event)),
                        name: "mailAddress",
                        placeholder: "test@example.com",
                        class: "text-field",
                        disabled: loading.value,
                        onFocus: focus,
                        onBlur: blur,
                        tabindex: "7"
                      }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                      _createElementVNode("div", null, [
                        _createVNode(_unref(ErrorMessage), { name: "mailAddress" }, {
                          default: _withCtx(({ message }) => [
                            _createElementVNode("p", _hoisted_21, _toDisplayString(message), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                (!isUser.value)
                  ? (_openBlock(), _createBlock(CommonButton, {
                      key: 0,
                      data: {
            status: !valid || loading.value ? 2 : 0,
            button: loading.value ? `登録中` : _unref(userInfoStore).isRegistFromProjectDetail ? `次へ` : `登録`,
          },
                      onClick: ($event: any) => (valid && !loading.value ? onSubmit() : ''),
                      disabled: !valid || loading.value
                    }, null, 8 /* PROPS */, ["data", "onClick", "disabled"]))
                  : (_openBlock(), _createBlock(CommonButton, {
                      key: 1,
                      data: {
            status: !valid || loading.value  ? 2 : 0,
            button: loading.value ? `更新中` : `更新`,
          },
                      onClick: ($event: any) => (valid && !loading.value ? onSubmit() : ''),
                      disabled: !valid || loading.value
                    }, null, 8 /* PROPS */, ["data", "onClick", "disabled"]))
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["validationSchema"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})